import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { tint } from "polished";
import Checked from "@engineering/icons/checked";
import Info from "@engineering/icons/info";
import Tipp from "@engineering/icons/tipp";
import Warning from "@engineering/icons/warning";
import { MessageSeverity } from "./Message.types";
var getColorBySeverity = function(severity) {
    switch(severity){
        case MessageSeverity.SUCCESS:
            return "success";
        case MessageSeverity.ERROR:
            return "error";
        default:
            return "info";
    }
};
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "ekyjnms0"
})("display:", function(param) {
    var visible = param.visible;
    return visible ? "flex" : "none";
}, ";margin:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";border:", function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.color.natural20);
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";background:", function(param) {
    var theme = param.theme, severity = param.severity;
    return tint(0.8, theme.color[getColorBySeverity(severity)]);
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";font-size:1rem;line-height:1.5;");
var Content = /*#__PURE__*/ styled("div", {
    target: "ekyjnms1"
})("flex-grow:1;");
var Headline = /*#__PURE__*/ styled("div", {
    target: "ekyjnms2"
})("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";");
var IconStyles = /*#__PURE__*/ css("flex-shrink:0;width:1.5rem;height:1.5rem;");
var InfoIcon = /*#__PURE__*/ styled(Info, {
    target: "ekyjnms3"
})(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";");
var TipIcon = /*#__PURE__*/ styled(Tipp, {
    target: "ekyjnms4"
})(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";");
var ErrorIcon = /*#__PURE__*/ styled(Warning, {
    target: "ekyjnms5"
})(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.error;
}, ";");
var SuccessIcon = /*#__PURE__*/ styled(Checked, {
    target: "ekyjnms6"
})(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.success;
}, ";");
export { Wrapper, Headline, Content, InfoIcon, TipIcon, ErrorIcon, SuccessIcon };
